import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  OfferService,
  StyleService,
  TemplateService,
  LogService,
} from '../../services';
import { Campaign, KnownReward } from '../../models';
import { MainTemplate, TemplateSetting } from '../../models/template';
import { Observable, of, take } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { InteractionType } from '../../models/interaction';
import { ChooseRewardItem } from '../../models/chooseReward';
import { LogType, LogSource } from '../../models/common';
import { OfferModalComponent } from '../offer-modal/offer-modal.component';

@Component({
  selector: 'app-choose-modal',
  templateUrl: './choose-modal.component.html',
  styleUrls: ['./choose-modal.component.scss'],
})
export class ChooseModalComponent implements OnInit, OnDestroy {
  @Output() onDetailClose: EventEmitter<any> = new EventEmitter();
  public isLoaded = false;
  public mainTemplate!: MainTemplate;
  public isRewardConfirmed: boolean = false;
  public slides: any = [];
  public itemsPerPage: 4 | 6 = 4;
  private isInteraction: InteractionType = InteractionType.None;

  @Input() chooseRewardsList: ChooseRewardItem[] = [];
  @Input() tab: TemplateSetting;
  @Input() accessRequestId: string;
  @Input() instanceId: string;
  @Input() campaign: Campaign;
  @Input() lobbyToken: string;
  @Input() indexesOffer: [number, number];

  constructor(
    public readonly styleService: StyleService,
    private readonly offerService: OfferService,
    private readonly dialogRef: MatDialogRef<any>,
    private readonly dialog: MatDialog,
    private readonly templateService: TemplateService,
    private readonly logService: LogService,
    private snackbar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.isLoaded = false;
    this.templateService
      .templateData$()
      .pipe(take(1))
      .subscribe((template) => {
        this.isLoaded = true;
        this.mainTemplate = template;
      });
    this.setSlides(this.chooseRewardsList, this.itemsPerPage);
  }

  chooseReward(card: any) {
    card.isSelected = !card.isSelected;
    this.chooseRewardsList.forEach((element) => {
      if (card.id !== element.id) element.isSelected = false;
    });
  }

  confirmChoosenReward() {
    let selectedReward = this.chooseRewardsList.find(
      (element) => element.isSelected === true
    );
    if (selectedReward) {
      this.offerService
        .claimChooseRaward(this.instanceId, selectedReward.id)
        .subscribe(
          () => {
            // OC-483 when reward chosen has redeemOnPrint/redeemOnIssue/printOnIssue, let the offer-modal
            // handle the aforementioned behaviour, otherwise close choose-modal without doing anyhting else
            const shouldClose = (selectedReward?.customProperties?.printOnIssue && selectedReward?.customProperties?.redeemOnPrint) || 
                                  selectedReward?.customProperties?.redeemOnIssue;
            this.isRewardConfirmed = true;
            setTimeout(() => {
              this.openDetail(shouldClose);
            }, 1000)
          },
          () => {
            this.snackbar.openFromComponent(SnackbarComponent, {
              panelClass: 'error',
              duration: 3000,
              horizontalPosition: 'end',
              data: {
                type: 'error',
                message: 'Reward confirm failed. Please try again',
              },
            });
          }
        );
    }
  }

  public openDetail(closeModal: boolean): void {
    let request: Observable<KnownReward> = of(this.campaign.knownReward);
    request = this.offerService.getCamapign(
      this.campaign.id,
      this.accessRequestId,
      this.campaign.schedule.schedulerId
    );

    request.pipe(take(1)).subscribe({
      next: async (rewardData) => {
        this.offerService.setDefaultCustomProperties(rewardData);
        this.campaign.knownReward = rewardData;
        this.onDetailClose.emit({
          reward: this.campaign.knownReward,
          closeModal 
        });
      },
      error: (err) => {
        this.logService.writeLog(
          JSON.stringify(`
            Open offer details: Campaign Id - ${this.campaign.id}
            Error:${JSON.stringify(err)}`
          ),
          LogType.ERROR,
          LogSource.MODAL
        );
      },
    });
  }

  isNotChosenAnyReward() {
    return !this.chooseRewardsList.some((element) => element.isSelected);
  }

  setSlides(chooseRewardsList: ChooseRewardItem[], size: number) {
    for (let i = 0; i < Math.ceil(chooseRewardsList.length / size); i++) {
      this.slides[i] = chooseRewardsList.slice(i * size, i * size + size);
    }
  }

  public getIconSize(size: string | null | undefined): string {

    if (!size) return '40px';
    const parsed = size.match(/\d+/g);

    return parsed?.[0] ? `${parsed[0]}px` : '40px';
  }

  public closeModal(shouldClose: boolean = true): void {
    // OC-483 - shouldClose is for when reward chosen has redeemOnPrint/redeemOnIssue/printOnIssue, 
    // let the offer-modal handle the aforementioned behaviour, otherwise close choose-modal without doing anyhting else
    this.dialogRef.close(shouldClose);
  }

  ngOnDestroy(): void {}
}